<template>
     <el-dialog
    title="查看详情"
    :visible.sync="dialogVisible"
    :close-on-click-modal="false"
    width="140rem">
    <div class="content">
        <div class="left-box">
            <p class="title">{{title}}实训记录</p>
            <div class="record-box" v-infinite-scroll="loadTrain">
                <no-data v-if="trainData.length==0"></no-data>
                <div v-for="(item,index) in trainData" class="train-item" @click="changeTrain(item)" :class="{active:currentSoftware.optFlag==item.optFlag}" :key="index">
                    <div v-show="currentSoftware.id==item.id" class="line-active"></div>
                    <text-overflow class="software-name" :content="item.softwareName"></text-overflow>
                    <!-- <p class="software-name">{{ item.softwareName }}</p> -->
                    <p class="start-time">开始时间:{{ item.beginTime }}</p>
                    <div class="bottom">
                        <div>
                            <p>在线时长：</p>
                            <p>{{ item.onlineTime }}</p>
                        </div>
                        <div>
                            <p>实训总分：</p>
                            <p>{{ item.score }}</p>
                        </div>
                    </div>
                </div>
            </div>
        </div>
        <div class="right-box">
            <p class="title" style="margin-left: 4rem;">操作记录</p>
            <div class="table-box">
                <Table
                    :totalSize="scroePages.total"
                    :pagination="true"
                    :operationWidth="350"
                    :currentPage="scroePages.current"
                    @changeCurrentPage="changeCurrentPage"
                    @changePageSize="changePageSize"
                    :pageSize="scroePages.size"
                    navHeight=40
                    ref="table"
                    :tableData="scoreData"
                    :tableKey="tableKey"
                >
                <template slot="courseCount" slot-scope="data">
                    <p style="color: #387DFF;cursor: pointer;">{{ data.data.row.courseCount }}</p>
                </template>
            </Table>
            </div>
        </div>
    </div>
    </el-dialog>
</template>

<script>
import { PageQueryTrainingScore,PageQueryUserTrainingRecord } from '@/api/trainTask';
import NoData from '../../common/NoData.vue';
import TextOverflow from '../../common/TextOverflow.vue';
    export default {
  components: { NoData, TextOverflow },
        data(){
            return {
                dialogVisible:false,
                taskId:'',
                /**实训记录数据 */
                trainData:[],
                userId:'',
                title:'',
                /**实训得分数据 */
                scoreData:[],
                /**实训详情分页 */
                pages:{
                    current:1,
                    size:10,
                    total:0
                },
                /**实训得分详情分页 */
                scroePages:{
                    current:1,
                    size:10,
                    total:0
                },
                currentSoftware:{},
                tableKey:[
                    {name: '操作名称', value: 'optDescribe'},
                    {name: '操作时长', value: 'optTime'},
                    {name: '开始时间', value: 'startTime'},
                    {name: '结束时间', value: 'endTime'},
                    {name: '满分', value: 'fullScore'},
                    {name: '得分', value: 'score'},
                ]
            }
        },
        methods:{
            /**个人中心-分页查询实训得分详情 */
            pageQueryTrainingScore(){
                let params={
                "current": this.scroePages.current,
                "optFlag": this.currentSoftware.optFlag,
                "size": this.scroePages.size
                }
                PageQueryTrainingScore(params).then(res=>{
                    if(res.code==200){
                        this.scroePages.total=res.data.total;
                        this.scoreData=res.data.records;
                    }
                })
            },
            /**分页查询用户实训详情 */
            pageQueryUserTrainingRecord(){
                return new Promise((resolve)=>{
                    let params={
                    "current": this.pages.current,
                    "size": this.pages.size,
                    "taskId": this.taskId,
                    "userId": this.userId||this.$store.state.user.userInfo.id
                    }
                    PageQueryUserTrainingRecord(params).then(res=>{
                        if(res.code==200){
                            this.pages.total=res.data.total;
                            if(this.pages.current==1){
                                this.trainData=res.data.records;
                            }else{
                                this.trainData=[...this.trainData,...res.data.records];
                            }
                            if(this.trainData.length>0){
                                this.currentSoftware=this.trainData[0];
                                this.pageQueryTrainingScore();
                            }else{
                                this.currentSoftware={};
                                this.scoreData=[];
                            }
                            this.dialogVisible=true;
                            resolve();
                        }
                    })
                    })
            },
            /**切换实训 */
            changeTrain(item){
                this.scroePages.current=1;
                this.currentSoftware=item;
                this.pageQueryTrainingScore();
            },
            /**下拉加载实训详情 */
            loadTrain(){
                let total=this.pages.current*this.pages.size;
                if(total>=this.pages.total)return;
                this.pages.current++;
                this.pageQueryUserTrainingRecord();
                console.log('loading........')
            },
            changeCurrentPage(e){
                this.scroePages.current=e;
                this.pageQueryTrainingScore();
            },
            changePageSize(){
                this.scroePages.current=1;
                this.scroePages.size=10;
                this.pageQueryTrainingScore();
            }
        }
    }
</script>

<style lang="less" scoped>
/deep/.el-dialog{
    border: 1px solid #e0e8f2;
    border-radius: 1.5rem;
}
/deep/.el-dialog__title{
    font-weight: 700;
    color: #334681;
    font-size: 16px;
}
.content{
    height: 60rem;
    border: 1px solid #e0e8f2;
    border-radius: 1.5rem;
    display: flex;
    color: #334681;
    .left-box{
        padding: 2rem;
    }
    .right-box{
        padding: 2rem 0;
        border-left: 1px solid #e0e8f2;
        flex: 1;
    }
}
.title{
            font-weight: 700;
            font-size: 16px;
    }
.table-box{
    height: calc(100% - 5rem);
    width: 100%;
    margin-top: 2.5rem;
}
.record-box{
    height: calc(100% - 5rem);
    margin-top: 2.5rem;
    width: 23.6rem;
    overflow: auto;
    &> :nth-child(n){
        margin-top: 1.5rem;
    }
    &> :nth-child(1){
        margin-top: 0;
    }
    .train-item{
        width: 100%;
        height: 9.6rem;
        border: 1px solid #e5edf7;
        border-radius: 0.8rem;
        box-shadow: 0px 0px 1.5rem 0px rgba(231,236,239,0.10); 
        padding: 1rem 2.1rem;
        position: relative;
        cursor: pointer;
    }
}
.software-name{
    font-weight: 700;
}
.start-time{
    color: #8590B3;
    font-size: 12px;
    margin-top: 1rem;
}
.bottom{
    font-size: 14px;
    margin-top: 1.3rem;
    display: flex;
    justify-content: space-between;
    &> :nth-child(n){
        display: flex;
        &> :nth-child(1){
            color: #8590B3;
        }
        &> :nth-child(2){
            font-weight: 700;
        }
    }
}
.active{
    background-color: #E5EDF7 !important;
}
.line-active{
    width: 3px;
    height: 7.6rem;
    background-color: var(--blue);
    position: absolute;
    top: 50%;
    left: 0;
    transform: translateY(-50%);
}
/deep/.nodata-img{
    width: 12rem !important;
}
/deep/.el-table--border {
    border: none;
}
</style>